import Vue from 'vue';

Vue.config.devtools = true
const mutations = {
    setGiftCollections(state, payload) {
        state.giftCollections = payload;
    },
    updateGiftCollection(state, payload) {
        const {id,products, value, category} = payload;
        let currentIndex = state.giftCollections.findIndex(x => x.id == id);
        if(currentIndex > -1){
            Vue.set(state.giftCollections[currentIndex], "collectionProducts", products);
            Vue.set(state.giftCollections[currentIndex], "value", value);
            Vue.set(state.giftCollections[currentIndex], "category", category);
        }
    },
    setSelectedCollection(state, payload) {
        state.selectedCollection = payload;
    },
    setAddressQty(state, payload){
        state.addressQty = payload;
    },
    setEmailFile(state, payload){
        state.emailFile = payload;
    },
    setEmailFileData(state, payload){
        state.emailFileData = payload;
    },
    setMultipleNotificationDate(state, payload){
        state.multipleNotificationDate = payload;
    },
    setSelectedFilters(state,payload){
        let currentIndex = state.selectedFilters.findIndex(x => x.title == payload.title);
        if(currentIndex > -1){
          if(payload.filters.length > 0){
            Vue.set(state.selectedFilters[currentIndex],"filters", payload.filters);
          }
          else{
            state.selectedFilters.splice(currentIndex, 1);
          }
        }
        else{
          state.selectedFilters.push(payload);
        }
      },
};

export default mutations;
